import { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { buscarMasterAtual } from '../api/master';
import { Master } from '../types';

interface MasterAuthContextValue {
  master: Master | null;
  setMaster: (master: Master | null) => void;
  carregando: boolean;
}

const MasterAuthContext = createContext<MasterAuthContextValue | null>(null);

export function MasterAuthProvider({ children }: { children: ReactNode }) {
  const [master, setMaster] = useState<Master | null>(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    buscarMasterAtual()
      .then(setMaster)
      .catch(() => setMaster(null))
      .finally(() => setCarregando(false));
  }, []);

  return (
    <MasterAuthContext.Provider value={{ master, setMaster, carregando }}>
      {children}
    </MasterAuthContext.Provider>
  );
}

export function useMasterAuth(): MasterAuthContextValue {
  const context = useContext(MasterAuthContext);
  if (!context) {
    throw new Error('useMasterAuth deve ser usado dentro de um MasterAuthProvider.');
  }
  return context;
}
